import React, { Component } from 'react';
import Slider from 'react-slick';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';
import TestimFamily from '../../images/testimfamily.png';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const dotsSettings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    focusOnSelect: true,
};
class WhatParentsSay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
        });
    }

    render() {
        return (
            <section className="page-section bg-secondary text-white testimsec">
                <h2 className="yellowtxt">What Parents Say</h2>
                <div
                    id="myCarousel"
                    className="carousel slide"
                    data-ride="carousel"
                >
                    <Slider
                        asNavFor={this.state.nav2}
                        ref={slider => (this.slider1 = slider)}
                        {...dotsSettings}
                        className="carousel-indicators"
                    >
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        
                    </Slider>
                    <Slider
                        {...settings}
                        asNavFor={this.state.nav1}
                        ref={slider => (this.slider2 = slider)}
                        className="carousel-inner"
                    >
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “Could not be more thankful or grateful that this gym opened up near us. I recommend whole-heartedly.”</p>
                            <p className="overview">Chelsea D.</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “A clean, friendly, relaxed place for neurodivergent kids to let off steam. Not too crowded when we went. Music was pleasant. Environment was very easy on the senses (the kids didn't even need ear protection). Thank you for this!”</p>
                            <p className="overview">Danielle C. </p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “Very friendly staff, clean play area, and lots of sensory equipment/toys for kids to try out. Both my kids had an amazing time." </p>
                            <p className="overview">Sherri L. </p>
                        </div>

                         <div className="item carousel-item">
                            <p className="testimonial">
                            “Great option for an indoor playground, both for kids/parents who are neurodivergent and those that are not. Clean, safe equipment and a price that simply cannot be beat. We often go to the South Shore outdoor playground, but during peak times that can be overwhelming. We will definitely be back to 'we rock the spectrum.'" </p>
                            <p className="overview">Bryan M. </p>
                        </div> 
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “What a gem! The best indoor playground in town. It's inclusive to all kids, neurodivergent and neurotypical. Clean, big open space with new equipment and a great toddler section. I prefer this playground to other indoor playgrounds because it's not as overstimulating.”</p>
                            <p className="overview">Rise D.</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “I am happy to see a place like this is now available in Hawaii. There are a ton of swinging, rolling, spinning things for safe physical activity and there are a ton of other quieter activities like kitchen set, tool station, arts & crafts room, touch/feel elements. Thank you for creating this wonderful place for kids of all abilities! I've seen it first hand that the community needed this.”</p>
                            <p className="overview">Emari H.</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “Great, clean place to take the kids to burn energy! Relaxing environment with great ownership. The kids were easily entertained for 2 hours! Lots of swings, zip lines, monkey bars, roller slide, ect. We parked at the opera house and didn’t have to unload the kids street side. Thanks for creating a fun environment!" </p>
                            <p className="overview">Aubrey R. </p>
                        </div>
                       
                    </Slider>
                    <img
                        className="quoteimg"
                        src={TestimFamily}
                        alt="Testimonials family"
                    />
                </div>
            </section>
        );
    }
}

export default WhatParentsSay;
